import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { DepartmentService } from '../../main-layout/department/department.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { Groups } from '../../utility/modals';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-departmentmodal',
  templateUrl: './departmentmodal.component.html',
  styleUrls: ['./departmentmodal.component.css']
})
export class DepartmentmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  countyList = [];
  hubList = []
  stateList = []
  regionList = []
  cityList = [];
  locationtype = [];
  departmentList = [];
  groups: any;
  groupsarray: Array<Groups>;
  saveTitle = 'Add'
  auditcausetype: any;
  departmentform: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  tempDepartmentUpdate: any;
  tempdepartment: any;
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  existingdetails: any = {}
  public validation_message = {
    'departmentname': [{ type: 'required', message: 'Department is required' },
    { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
    { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    { type: 'maxlength', message: 'Maximum length exceeded' },
    { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    ],
    'deptinitial': [{ type: 'required', message: 'Department Initial is required' },
    { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
    { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    { type: 'maxlength', message: 'Maximum length exceeded' },
    { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
  }
  constructor(
    private departmentService: DepartmentService,
    private fb: FormBuilder, private utilityservice: Utilityservice,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private spinnerservice: NgxSpinnerService,
    private el: ElementRef
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title == 'Modify Department') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.existingdetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData()
    this.departmentform.get('activeflag')?.valueChanges.subscribe((value) => {
      this.updateActiveFlagOptions(value);
    });

    this.updateActiveFlagOptions(this.departmentform.get('activeflag')?.value);

  }
  getData() {
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0])
    }
  }



  updateActiveFlagOptions(flagValue: string) {
    if (flagValue === 'Y') {
      this.activeFlag = [
        { labelname: 'Active', value: 'Y' }
      ];
    } else {
      this.activeFlag = [
        { labelname: 'Active', value: 'Y' },
        { labelname: 'Inactive', value: 'N' }
      ];
    }
  }


  patchValueForms(data) {
    this.departmentform.patchValue({
      'activeflag': data?.activeflag,
      'departmentname': data?.departmentname,
      'deptinitial': data?.deptinitial
    });

  }
  
  formInitiliaze() {
    this.departmentform = this.fb.group({
      departmentname: ['',
        Validators.compose([Validators.required,
        Validators.maxLength(50),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
        ])],
      deptinitial: ['', Validators.compose([Validators.required,
      Validators.maxLength(20),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)

      ])],
      activeflag: ['Y'],

    })
  }

  addDepartment() {
    console.log(this.departmentform, "form");
    console.log(this.departmentform.invalid);

    if (this.departmentform.invalid) {
      this.validateAllFormFields(this.departmentform, this.el);
    }

    else if (this.saveTitle == 'Modify') {
      this.modifyDepartment(this.departmentform.value)
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          let data = this.departmentform.value;
          data['csrftoken'] = this.CSRFToken;
          this.spinnerservice.show()
          this.departmentService.addDepartment(this.departmentform.value).subscribe((data) => {
            this.tempdepartment = data;
            this.spinnerservice.hide();
            if (this.tempdepartment.response == 'exists') {
              Swal.fire("Department name or initial already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire("Department added successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
             this.spinnerservice.hide();
            if (error.error.response == 'html') {
                      Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                      })
                    }       
              else{ 
            Swal.fire("Error!", error.error.response, "error");}
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
    }
  }


  modifyDepartment(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          let data = this.departmentform.value;
          data['csrftoken'] = this.CSRFToken
          data.activeflag = this.departmentform.get('activeflag').value;
          data.departmentid = this.existingdetails[0].departmentid
          this.departmentService.updateDepartment(this.departmentform.value).subscribe((data) => {
            this.tempdepartment = data;
            this.spinnerservice.hide();
            if (this.tempdepartment.response == 'exists') {
              Swal.fire("Department name or initial already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire("Department modified successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            if (error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                  })
                 }       
            else{ 
            Swal.fire("Error!", error.error.response, "error");}
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
  }
  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}